import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const GridIcon = withSvgIcon(
    <g id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="22" height="22" fill="none" strokeWidth="1.5" />

        <line x1="12" y1="1" x2="12" y2="23" strokeWidth="1.5" />

        <line x1="1" y1="8" x2="23" y2="8" strokeWidth="1.5" />
        <line x1="1" y1="15" x2="23" y2="15" strokeWidth="1.5" />
    </g>,
    "0 0 24 24"
);
